import React, { useState } from 'react'
import schoolLogo from '../../Assets/founder1.jpg'
import schoolLogo2 from '../../Assets/founder2.jpeg'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'antd'

const Header = () => {
  const navigate = useNavigate()
  const [showConfirm, setShowConfirm] = useState(false)

  const handleLogout = () => {
    sessionStorage.clear() // ✅ Clear session storage
    navigate('/') // ✅ Navigate to homepage
  }

  return (
    <div>
      <div className="top-header">
        <img src={schoolLogo} alt="Left Logo" className="school-logo" />
        <h1 className="school-title">श्री वारणा विद्यालय, वारणानगर</h1>
        <img src={schoolLogo2} alt="Right Logo" className="school-logo1" />
      </div>

      <div className="btn-row d-flex justify-content-end">
        <button className="custom-btn" onClick={() => setShowConfirm(true)}>
          Logout <span className="logout-arrow">→</span>
        </button>
      </div>

      {/* CONFIRM LOGOUT MODAL */}
      <Modal
        title="Confirm Logout"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onOk={handleLogout}
        okText="Yes, Logout"
        cancelText="Cancel"
      >
        <p>Are you sure you want to logout?</p>
      </Modal>
    </div>
  )
}

export default Header
